import React from 'react';

export const Card = ({ children, className = '' }) => {
  return (
    <div
      className={`bg-background-surface rounded-lg border border-border shadow-card ${className}`}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '' }) => {
  return (
    <div className={`px-4 sm:px-6 py-3 sm:py-4 border-b border-border ${className}`}>
      {children}
    </div>
  );
};

export const CardTitle = ({ children, className = '' }) => {
  return (
    <h3 className={`text-base sm:text-lg font-semibold text-text-primary ${className}`}>
      {children}
    </h3>
  );
};

export const CardContent = ({ children, className = '' }) => {
  return <div className={`p-4 sm:p-6 ${className}`}>{children}</div>;
};
